import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
var styles = {
  row: {
    backgroundColor: '#334058',
    color: 'white',
    textAlign: 'center',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    height: '32px',
    lineHeight: '32px'
  },
  border: {
    borderLeft: '1px solid gray'
  },
  'border:first-type': {
    borderLeft: 0
  }
};

var HeaderRow = function HeaderRow(props) {
  var renderColumns = function renderColumns() {
    return props.columns.map(function (column, i) {
      return React.createElement(Grid, {
        item: true,
        xs: 3,
        key: i,
        className: props.classes.border,
        "data-testid": "defiExpansion-headerRow-column-".concat(i)
      }, column.get('label'));
    });
  };

  return React.createElement(Grid, {
    container: true,
    className: props.classes.row,
    "data-testid": "defiExpansion-headerRow"
  }, renderColumns());
};

export default withStyles(styles)(HeaderRow);